export default "__VITE_ASSET__QocczRtm__"